import { render, staticRenderFns } from "./ListarProductos.vue?vue&type=template&id=56cc81cf&"
import script from "./ListarProductos.vue?vue&type=script&lang=js&"
export * from "./ListarProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports